import { atom } from "jotai";
export const totalRespuestasUsuarioAtom = atom(0);